export const environment = {
  production: false,
  baseUrl: 'https://pna-qa.azure.chevron.com',
  apiUrl: 'https://pna-mod-api-qa.azure.chevron.com',
  calSettings: {
    autoSignIn: true,
    popupForLogin: false, // Changed to true to avoid redirect issues during local dev
    cacheLocation: 'localStorage',
    instance: 'https://login.microsoftonline.com/',
    tenantId: 'fd799da1-bfc1-4234-a91c-72b3a1cb9e26',
    clientId: 'f339d3b5-0f49-42a3-a895-922ce8443cc5',
    redirectUri: 'https://pna-qa.azure.chevron.com',
    //Scopes: ['openid', 'profile', 'User.Read', 'offline_access'],
    oidcScopes: ['openid', 'profile', 'User.Read', 'offline_access'],
    graphScopes: ['User.Read', 'User.Read.All']
  },
  allowedFileFormats: '.pdf,.doc,.docx,.xlsx,.xls,.jpg,.jpeg,.msg,.zip,.png',
  allowedZipInnerFileFormats: '.pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg,.txt,.msg'
};
